import './TesterCard.scss';
import { Card } from 'react-bootstrap';
import { reactPlugin } from '../../../../services/appInsights.service';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { Tester } from '../../../../interfaces/tester.interface';
import { NavLink } from "react-router-dom";

type TParams = { tester: Tester };

function TesterCard({ tester }: TParams) {
  return (
    <Card className="row rounded tester-card shadow-sm cursor-shadow-md" as={NavLink as any} color="#fff" to={"/tester/" + tester.testerId}>
      <div className="col tester-card-count rounded-left text-center tester-gold-color">
        <div className="tester-card-count-num">{tester.automatedVehiclesCount + tester.pddsCount}</div>
        <div>{tester.automatedVehiclesCount} Vehicle{tester.automatedVehiclesCount > 1 && "s"} / {tester.pddsCount} PDD{tester.pddsCount > 1 && "s"}</div>
      </div>
      <div className="col text-right">
        <div className="row tester-card-body">
          <div className="col border-bottom text-left p-2">
            <div className="tester-name">{tester.testerName}</div>
            <div className="tester-name"><small><small>Tester ID: <strong>{tester.testerId}</strong></small></small></div>

          </div>
        </div>
        <div className="row tester-card-footer">
          <div className="col text-center">
            Add New Vehicle / PDD
          </div>
        </div>
      </div>
    </Card>
  );
}

export default withAITracking(reactPlugin, TesterCard);